import { Children } from 'react';
import { useTranslation } from 'react-i18next';

import { Delegate } from 'model/Delegate';
import { DELEGATE_TYPE, YN_TYPE } from 'types/enumType';

type DelegateTableProps = {
  type: DELEGATE_TYPE;
  list: Delegate[];
  onDelete?: (agentId: number) => void;
};

export default function DelegateTable({
  type,
  list,
  onDelete = () => {},
}: DelegateTableProps) {
  const { t } = useTranslation();
  const isDelegate = type === DELEGATE_TYPE.DELEGATE;

  return (
    <table className={'tbl_ht01 setting-equip-table'}>
      <caption>{t('conclusion.searchList')}</caption>
      <colgroup>
        <col />
        <col />
        <col />
        <col />
        <col />
        <col width={'120'} />
      </colgroup>
      <thead>
        <tr>
          <th>{`${
            isDelegate ? t('coop.mandate-user') : t('coop.delegate-user')
          } ID`}</th>
          <th>{`${
            isDelegate ? t('coop.mandate-user') : t('coop.delegate-user')
          } ${t('user.name')}`}</th>
          <th>{t('conclusion.dept')}</th>
          <th>{t('shift.startDate')}</th>
          <th>{t('shift.endDate')}</th>
          <th>{isDelegate ? '회수' : t('communication.status')}</th>
        </tr>
      </thead>
      <tbody>
        {list.length === 0 && (
          <tr>
            <td colSpan={6}>{t('conclusion.noData')}</td>
          </tr>
        )}
        {Children.toArray(
          list.map((item) => (
            <tr>
              <td>{isDelegate ? item.agentAccount : item.userAccount}</td>
              <td>{isDelegate ? item.agentName : item.userName}</td>
              <td>{item.deptName}</td>
              <td>{item.startDate}</td>
              <td>{item.endDate}</td>
              {isDelegate ? (
                <td>
                  <button
                    type={'button'}
                    className={'orange_white_btn'}
                    onClick={() => onDelete(item.agentId)}
                  >
                    {t('coop.delegateDel')}
                  </button>
                </td>
              ) : (
                <td>
                  {item.activate === YN_TYPE.Y
                    ? t('user.activate')
                    : t('user.deactivate')}
                </td>
              )}
            </tr>
          )),
        )}
      </tbody>
    </table>
  );
}
